/**
 * Merge roster members into a data-athlete list so newly-created users
 * (who have no wearable data yet) still appear with placeholder values.
 */
export function mergeRosterIntoData(dataAthletes: any[], roster: any[], useUnifiedData: boolean): any[] {
    if (roster.length === 0) return dataAthletes;

    const rosterIds = new Set(roster.map((m) => m.id));
    // Exclude data rows for users no longer on the roster (readiness/recovery caches can lag behind membership)
    const stillOnTeam = dataAthletes.filter((a) => {
        const id = useUnifiedData ? a.id : a.athlete_id;
        return id != null && rosterIds.has(id);
    });

    const dataById = new Map<number, any>();
    for (const a of stillOnTeam) {
        const id = useUnifiedData ? a.id : a.athlete_id;
        if (id != null) dataById.set(id, a);
    }
    const merged = [...stillOnTeam];
    for (const member of roster) {
        if (!dataById.has(member.id)) {
            const displayName = [member.first_name, member.last_name].filter(Boolean).join(' ')
                || member.username || `User ${member.id}`;
            // Propagate connection flags from the roster member so the
            // card shows the correct connected/disconnected state immediately.
            if (useUnifiedData) {
                merged.push({
                    id: member.id,
                    name: displayName,
                    score: 0, tier: 'NO_DATA',
                    whoop_connected: member.whoop_connected || false,
                    garmin_connected: member.garmin_connected || false,
                    coros_connected: member.coros_connected || false,
                    oura_connected: member.oura_connected || false,
                    terra_connected: member.terra_connected || {},
                    hrv: { value: 0, trend: 0, average: 0, latest: 0, consistency: 0 },
                    rhr: { value: 0, trend: 0 },
                    recovery: { average: 0, latest: 0, trend: 0, data_points: 0 },
                    sleep: { average_duration: 0, latest_duration: 0, average_quality: 0, latest_quality: 0, average_efficiency: 0, data_points: 0 },
                    strain: { average: 0, latest: 0, total: 0, data_points: 0 },
                });
            } else {
                merged.push({
                    athlete_id: member.id,
                    athlete_name: displayName,
                    whoop_connected: member.whoop_connected || false,
                    garmin_connected: member.garmin_connected || false,
                    coros_connected: member.coros_connected || false,
                    oura_connected: member.oura_connected || false,
                    terra_connected: member.terra_connected || {},
                    recovery_data: [],
                });
            }
        }
    }
    return merged;
}
